// extracted by mini-css-extract-plugin
module.exports = {"container":"options-explained-drawer_container__qM4RL","textLink":"options-explained-drawer_textLink__xb99e"};